<template>
  <Catalog
    title="Услуги самозанятых"
    name-label="Название услуги"
    submit-error="Укажите название услуги."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    :exact-id="createId"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import Catalog from "../Catalog.vue";

export default {
  name: "WorkService",
  components: { Catalog },
  mixins: [ catalogs ],
  props: {
    createId: { type: Number }
  },
  methods: {
    async fetchData(id) {
      return await this.getWorkServiceById(id);
    },
    async putData(data) {
      return await this.putWorkServices(data);
    },
    async postData(data) {
      return await this.postWorkServices(data);
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkServices/WorkService.vue